import { render } from "./Nuevo.vue?vue&type=template&id=7c079f67&scoped=true"
import script from "./Nuevo.vue?vue&type=script&lang=js"
export * from "./Nuevo.vue?vue&type=script&lang=js"

import "./Nuevo.vue?vue&type=style&index=0&id=7c079f67&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c079f67"]])

export default __exports__